import { render } from "./HrApprovalCalender.vue?vue&type=template&id=5a83a618&scoped=true"
import script from "./HrApprovalCalender.vue?vue&type=script&lang=js"
export * from "./HrApprovalCalender.vue?vue&type=script&lang=js"

import "./HrApprovalCalender.vue?vue&type=style&index=0&id=5a83a618&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a83a618"]])

export default __exports__